import React, { useState, useEffect, useCallback } from "react";
import * as APIModels from "../../../../models";
import {
    OrganizationService,
    UserService,
} from "../../../../services/ClientService";
import { Checkbox } from "@material-ui/core";
import { Button } from "react-bootstrap";
import MaterialTable from "@material-table/core";
import SendModal from "./modals/SendModal";
import { LockOpen } from "@material-ui/icons";
import GenericModal from "../../../../components/shared/modals/GenericModal";

export default function UserList({
    organization,
}: {
    organization: APIModels.Organization;
}) {
    const [updatedOrganization, setUpdatedOrganization] = useState(
        new APIModels.Organization()
    );
    const [updatedUsers, setUpdatedUsers] = useState([] as APIModels.User[]);
    const [errorMessage, setErrorMessage] = useState("");
    const [modalShow, setModalShow] = useState(false);
    const [roles, setRoles] = useState([] as APIModels.Role[]);

    const refreshData = () => {
        if (updatedOrganization.id != "") {
            OrganizationService.users({
                organizationId: updatedOrganization.id ?? "",
                active: true,
            }).then(
                (resp) => {
                    if (resp.successful === true && resp.data) {
                        setUpdatedUsers([...resp.data]);
                    } else {
                        setErrorMessage(resp.errorMessage ?? "");
                    }
                },
                (error) => {
                    setErrorMessage(errorMessage);
                }
            );
            if (errorMessage !== "") {
                console.log(errorMessage);
                setErrorMessage(errorMessage);
            }
        }
    };

    const resendPasswordEmail = (usr: APIModels.User | APIModels.User[]) => {
        if (Array.isArray(usr)) {
            usr = usr[0];
        }
        UserService.forgotPassword({
            body: {
                email: usr.emailAddress,
            },
        }).then((resp) => {
            if (resp.successful === true && resp.data) {
                // show a success modal
            } else {
                setErrorMessage(resp.message ?? "");
            }
        });
    };

    useEffect(() => {
        setUpdatedOrganization(organization);
        if (organization && organization.id) {
            OrganizationService.users({
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                organizationId: organization.id ?? "",
            }).then(
                (resp) => {
                    if (resp.successful === true && resp.data) {
                        setUpdatedUsers([...resp.data]);
                        console.log(resp.data);
                    } else {
                        setErrorMessage(resp.errorMessage ?? "");
                    }
                },
                (error) => {
                    setErrorMessage(error);
                }
            );
            if (errorMessage !== "") {
                console.log(errorMessage);
                setErrorMessage("");
            }
        }
        UserService.roles().then(
            (resp) => {
                if (resp.successful === true && resp.data) {
                    setRoles([...resp.data]);
                } else {
                    setErrorMessage(resp.message ?? "");
                }
            },
            (error) => {
                setErrorMessage(error);
            }
        );
    }, [organization]);

    return (
        <>
            <div className="card text-center">
                <SendModal
                    show={modalShow}
                    organizationId={
                        updatedOrganization.id ?? APIModels.EmptyGuid
                    }
                    onClose={() => setModalShow(false)}
                />
                <Button
                    style={{
                        float: "right",
                        width: "5em",
                        margin: "0.75em",
                    }}
                    className="btn btn-primary"
                    onClick={() => setModalShow(true)}
                >
                    Add User
                </Button>
                <div className="card-body">
                    <div style={{ maxWidth: "100%", zIndex: -1 }}>
                        <MaterialTable
                            columns={[
                                {
                                    title: "ID",
                                    field: "id",
                                    editable: "never",
                                },
                                {
                                    title: "Username",
                                    field: "username",
                                },
                                {
                                    title: "Email Address",
                                    field: "emailAddress",
                                },
                                {
                                    title: "First Name",
                                    field: "firstName",
                                },
                                {
                                    title: "Last Name",
                                    field: "lastName",
                                },
                                {
                                    title: "Title",
                                    field: "title",
                                },
                                {
                                    title: "Role",
                                    field: "roleTitle",
                                },
                            ]}
                            data={updatedUsers}
                            title="Organization Users"
                            actions={[
                                {
                                    icon: () => <LockOpen />,
                                    tooltip: "Send Password Reset Email",
                                    onClick: (event, rowData) =>
                                        resendPasswordEmail(rowData),
                                },
                                {
                                    icon: "mail",
                                    tooltip: "Resend Verification Email",
                                    onClick: (event, rowData) => {
                                        UserService.resendConfirmationEmail({
                                            userId:
                                                (rowData as APIModels.User)
                                                    .id ?? "",
                                        }).then(
                                            (resp) => {
                                                if (
                                                    resp.successful &&
                                                    resp.data
                                                ) {
                                                    console.log("Email Resent");
                                                } else {
                                                    console.log(
                                                        "Email Not Resent"
                                                    );
                                                }
                                            },
                                            (error) => {
                                                console.log(error);
                                            }
                                        );
                                    },
                                    //(window.location.href = `/admin/attorneys/edit/Id=${rowData}`),
                                },
                            ]}
                            editable={{
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve, reject) => {
                                        UserService.update({
                                            id: oldData?.id ?? "",
                                            body: newData!,
                                        }).then(
                                            (resp) => {
                                                refreshData();
                                                resolve(null);
                                            },
                                            (error) => {
                                                console.log(error);
                                                resolve(null);
                                            }
                                        );
                                        resolve(null);
                                    }),
                                onRowDelete: (oldData) =>
                                    new Promise((resolve, reject) => {
                                        UserService.delete({
                                            id: oldData.id ?? "",
                                        }).then(
                                            (resp) => {
                                                refreshData();
                                                resolve(null);
                                            },
                                            (error) => {
                                                console.log(error);
                                                resolve(null);
                                            }
                                        );
                                        resolve(null);
                                    }),
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
